import { render, staticRenderFns } from "./EditResellerServiceComponent.vue?vue&type=template&id=02be3fe2"
import script from "./EditResellerServiceComponent.vue?vue&type=script&lang=js"
export * from "./EditResellerServiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports